export const NO_PROTECTION_PLAN = 'NO_PROTECTION_PLAN'
export const PROTECTION_PLAN = 'PROTECTION_PLAN'
export const PROTECTION_PLAN_WITH_THEFT_PROTECTION =
  'PROTECTION_PLAN_WITH_THEFT_PROTECTION'

export const AUTH_TOKEN = 'aluxo365customertoken'
